<template>
  <div class="cfa-root">
    <c-f-a-nav :alert="alertString">
      <template v-slot:title>
        <div
          v-if="
            (subscriptionData?.data && !subscriptionData?.data?.is_activated) ||
            subscriptionData == null
          "
          class="card-body p-0 mt-4 mb-0"
        >
          <div
            class="card-transparent cfa-warning-deadline py-3 px-2"
            style="
              border: 2px solid rgb(50, 204, 218);
              background-color: rgb(229, 245, 245);
              color: rgb(50, 204, 218);
              font-weight: 400;
            "
            v-if="!waitingAPIResponse && userRole == 'manager'"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div>
                {{ $t("follow_modules") }}
              </div>
              <div class="">
                <a href="/facturation/pricing"
                  ><button class="btn cfa-btn-primary">
                    {{ $t("subscribe") }}
                  </button></a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 pt-5 text-start mb-3">
          <h1 class="cfa-section-title">{{ $t("modules_title") }}</h1>
        </div>
      </template>
      <template v-slot:content>
        <div class="cfa-welcome">
          <div v-show="!waitingAPIResponse" class="cfa-page">
            <div>
              <content-filter
                @viewMode="getViewMode"
                @viewFilter="getViewFilter"
                :total1="totalModule"
                :total2="module_covered"
                :total3="allModulesPluzz.length"
                :isPluzz="allModulesPluzz.length > 0"
                :isModule="allModules.length > 0"
              ></content-filter>
            </div>
            <div class="my-4">
              <div class="cfa-searchbar-wrapper">
                <img
                  width="15"
                  src="/images/search-icon.png"
                  alt="search icon"
                  class="mt-3 ms-2"
                  style="position: absolute"
                />
                <input
                  type="search"
                  id="filter-input"
                  v-model="filterText"
                  :placeholder="$t('search_module')"
                  style="
                    background-color: rgb(255, 255, 255);
                    border: 1px solid rgb(229, 232, 242);
                    width: 250px;
                    padding-left: 30px;
                  "
                />
              </div>
            </div>
            <div
              v-if="this.allModules.length == 0"
              class="d-flex justify-content-center align-items-center oups"
              style="min-height: 70vh"
            >
              <div class="d-flex flex-column">
                <!-- <img v-if="this.organisationLogo" :src="this.organisationLogo" alt="empty content" style="width: 15em;"/> -->
                <img
                  src="@/assets/img/svg/cfa-ud-assets-05.svg"
                  alt="empty content"
                  style="width: 15em"
                />
                <span class="mt-3 fs-5 fw-bold">{{ $t("nothing_yet") }}</span>
              </div>
            </div>
            <div v-else>
              <div></div>
              <!-- Add this after the course-card row -->
              <div class="row" style="color: #132b4d">
                <course-card
                  @error="getModuleError"
                  v-for="(module, i) in this.filteredModules"
                  v-bind:key="i"
                  :id="module.id"
                  :type="getLocalizedContent(module, 'category')"
                  :preview="getLocalizedContent(module, 'module_image')"
                  :label="'Module ' + (i + 1)"
                  :finished="module.statut != 'available' ? false : false"
                  :started="i != 0 ? false : true"
                  :title="getLocalizedContent(module, 'title')"
                  :max__horaire="module.duration"
                  :viewMode="displayMode"
                  :filterMode="filterMode"
                ></course-card>
              </div>

              <!-- Pagination component -->
              <!-- <div class="row mt-4">
            <div class="col-12">
            <nav aria-label="Module pagination">
            <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo; {{ $t('previous') }}</a>
            </li>
            <li v-for="page in pages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages || totalPages === 0 }">
            <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">{{ $t('next') }} &raquo;</a>
            </li>
            </ul>
            </nav>
            </div>
            </div> -->
            </div>
          </div>
          <div v-show="waitingAPIResponse" class="cfa-page">
            <div
              class="d-flex justify-content-center align-items-center oups"
              style="min-height: 70vh"
            >
              <div class="preloader_center d-flex flex-column">
                <img
                  src="../../assets/brand/cfa-favicon1.png"
                  alt="cfa preloader"
                />
                <p class="pl-3 fw-bold">{{ $t("loading") }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <pre-loader v-show="waitingAPIResponse"/> -->
      </template>
    </c-f-a-nav>
    <c-f-a-footer></c-f-a-footer>
  </div>
</template>

<script>
/* eslint-disable */
import CFAFooter from "@/components/nav/CFAFooter.vue";
import CFANav from "@/components/nav/CFANav.vue";
import ContentFilter from "@/components/shared/ContentFilter.vue";
import CourseCard from "@/components/shared/course/CourseCard.vue";
import { getAPI } from "@/axios-api.js";
// import PreLoader from '@/components/shared/PreLoader.vue'
import { useStore } from "vuex";

export default {
  name: "DashboardView",
  setup() {
    const store = useStore();
  },
  components: {
    CFAFooter,
    CFANav,
    ContentFilter,
    CourseCard,
    // PreLoader,
  },
  data() {
    return {
      waitingAPIResponse: true,
      displayMode: "GROUP",
      filterMode: "ALL",
      allModules: [],
      alertString: null,
      totalInProgress: 0,
      totalModule: 0,
      module_covered: 0,
      module_progress: [],
      subscriptionData: [],
      organisationLogo: "",
      userRole: localStorage.getItem("role"),
      filterText: "",
      searchTimeout: null,
      // Updated pagination variables
      currentPage: 1,
      itemsPerPage: 20,
      paginationInfo: {
        count: 0,
        next: null,
        previous: null,
      },
      allModulesPluzz: [],
    };
  },
  computed: {
    filteredModules() {
      // Simply return the modules from the API
      // if (this.filterMode === "PLUZZ") {
      //   return this.allModulesPluzz;
      // }
      return this.allModules;
    },
    // Total number of pages based on API count
    totalPages() {
      return Math.ceil(this.paginationInfo.count / this.itemsPerPage);
    },
    // Array of page numbers for pagination
    pages() {
      const pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    searchTermlang () {
      return this.$i18n.locale === 'en' ? 'title_en' : 'title'
    }
  },
  methods: {
    getViewMode(e) {
      this.displayMode = e;
    },
    getViewFilter(e) {
      this.filterMode = e;
    },
    getModuleError(e) {
      console.log(e);
      //this.alertString = `${e}|alert-no|10000::`+Date.now()
    },
    retrieveUserSubscription() {
      this.waitingAPIResponse = true;
      getAPI
        .get(`subscriptions/find-subscription`)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.subscriptionData = response.data;
            this.organisationLogo =
              this.subscriptionData.data.organisation.logo;
          } else {
            //let msg = 'Oups ! something went wrong.'
            //this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          setTimeout(() => {
            this.waitingAPIResponse = false;
          }, 2000);
        })
        .catch((error) => {
          this.subscriptionData = error.data;
          if (error.response) {
            //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
          } else if (error.request) {
            //let msg = 'The request was made but no response was received. Please check your network.'
            //this.alertString = `${msg}|alert-no|8000::`+Date.now()
          } else {
            //let msg = 'Oups ! something went wrong.'
            //this.alertString = `${msg}|alert-no|5000::`+Date.now()
          }
          this.waitingAPIResponse = false;
        });
    }, 

    searchModules() {
      //this.waitingAPIResponse = true;
      getAPI
        .get(`modules/search?${this.searchTermlang}=${encodeURIComponent(this.filterText)}`)
        .then((response) => {
          if (response.status == 200) {
            let modulesData = response.data.results;
            this.allModules = modulesData.data || [];
          }
          //this.waitingAPIResponse = false;
        })
        .catch((error) => {
          console.error("Error searching modules:", error);
          //this.waitingAPIResponse = false;
        });
    },
    loadModules(url = null) {
      this.waitingAPIResponse = true;
      // Use the provided URL or construct the base URL with pagination parameters
      const apiUrl =
        url ||
        `modules/list_module_visible?page=${this.currentPage}&page_size=${this.itemsPerPage}`;

      getAPI
        .get(apiUrl)
        .then((response) => {
          if (response.status == 200) {
            // Extract both the modules data and pagination information
            let modulesData = response.data.results;
            this.allModules = modulesData.data || [];

            // Store pagination information from the API
            this.paginationInfo = {
              count: response.data.count || 0,
              next: response.data.next,
              previous: response.data.previous,
            };

            this.totalModule = this.paginationInfo.count;
          }
          this.waitingAPIResponse = false;
        })
        .catch((error) => {
          console.error("Error loading modules:", error);
          this.waitingAPIResponse = false;
        });
    },

    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;

        // If we have direct next/previous URLs, use them
        if (page > this.currentPage && this.paginationInfo.next) {
          this.loadModules(this.paginationInfo.next);
        } else if (page < this.currentPage && this.paginationInfo.previous) {
          this.loadModules(this.paginationInfo.previous);
        } else {
          // Otherwise construct URL with page parameter
          this.loadModules();
        }
      }
    },

    searchModules() {
      // Include pagination parameters in search
      getAPI
        .get(
          `modules/search?${this.searchTermlang}=${encodeURIComponent(this.filterText)}&page=${
            this.currentPage
          }&page_size=${this.itemsPerPage}`
        )
        .then((response) => {
          if (response.status == 200) {
            let modulesData = response.data.results;
            this.allModules = modulesData.data || [];

            // Update pagination info from search results too
            this.paginationInfo = {
              count: response.data.count || 0,
              next: response.data.next,
              previous: response.data.previous,
            };
          }
        })
        .catch((error) => {
          console.error("Error searching modules:", error);
        });
    },
    // getModulesPluzz() {
    //   getAPI
    //     .get(`module_pluzz/modules/accessible/`)
    //     .then((response) => {
    //       if (response.status == 200) {
    //         let modulesData = response.data.data;
    //         this.allModulesPluzz = modulesData || [];
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error loading modules:", error);
    //     });
    // },
    getLocalizedContent(module, field) {
      if (this.$i18n.locale === 'en') {
        return module[field + '_en'];
      }
      return module[field];
    },
  },
  async mounted() {
    this.retrieveUserSubscription();
    console.log(this.$route);
    if (this.$route.query.reason) {
      if (this.$route.query.reason == "no_subscription") {
        //
        this.$swal({
          title: this.$t("no_subscription_title"),
          text: this.$t("please_subscribe"),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$t("close"),
        });
      } else if (this.$route.query.reason == "unfinished_modules") {
        this.$swal({
          title: this.$t("modules_title"),
          text: this.$t("finish_modules_exam"),
          type: "warning",
          showCancelButton: false,
          confirmButtonText: this.$t("close"),
        });
      }
    }
    /*this.waitingAPIResponse = true
    getAPI.get('modules/list_module_visible?page_size=12')
    .then(response => {
      console.log(response)
      if(response.status == 200) {
        let modulesData = response.data.results
        this.allModules = modulesData.data
        this.totalModule = modulesData.data.length
        // TODO: make this dynamic
        this.totalInProgress = 1
      }
      else {
        //let msg = 'Oups ! something went wrong.'
        //this.alertString = `${msg}|alert-no|5000::`+Date.now()
      }
      setTimeout(() => {
        this.waitingAPIResponse = false
      }, 2000);
    })
    .catch(error => {
      if (error.response) {
        //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
      }
      else if (error.request) {
        //let msg = 'The request was made but no response was received. Please check your network.'
        //this.alertString = `${msg}|alert-no|8000::`+Date.now()
      }
      else {
        //let msg = 'Oups ! something went wrong.'
        //this.alertString = `${msg}|alert-no|5000::`+Date.now()
      }
      this.waitingAPIResponse = false
    })
    */
    this.loadModules();

    this.waitingAPIResponse = true;
    getAPI
      .get(`stat_module/?user_id=${localStorage.user}`)
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          let progress = response.data;
          this.module_covered = progress.length;
          for (let i = 0; i < progress.length; i++) {
            this.module_progress.push({
              module: progress[i].number,
              progress: progress[i].value,
            });
          }
          for (let i = this.module_progress.length; i < 12; i++) {
            this.module_progress.push({ module: i + 1, progress: 0 });
          }
        } else {
          //let msg = 'Oups ! something went wrong.'
          //this.alertString = `${msg}|alert-no|5000::`+Date.now()
        }
        setTimeout(() => {
          this.waitingAPIResponse = false;
        }, 2000);
      })
      .catch((error) => {
        if (error.response) {
          //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
        } else if (error.request) {
          //let msg = 'The request was made but no response was received. Please check your network.'
          //this.alertString = `${msg}|alert-no|8000::`+Date.now()
        } else {
          //let msg = 'Oups ! something went wrong.'
          //this.alertString = `${msg}|alert-no|5000::`+Date.now()
        }
        this.waitingAPIResponse = false;
      });
    // this.getModulesPluzz();
  },
  watch: {
    filterText() {
      // Clear any existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Set a new timeout
      this.searchTimeout = setTimeout(() => {
        if (this.filterText.trim() !== "") {
          this.searchModules();
        } else {
          this.loadModules();
        }
      }, 500); // Wait 500ms after user stops typing
    },
  },
};
</script>

<style scoped></style>
